import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { IdentityProvidersPage } from '@/features/access/identity-providers/identity-provider-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Les fournisseurs d'identité se rejoignent depuis les membres de l'organisation. */
export const Route = createFileRoute('/$tenant/identity-providers/')({ component: IdentityProvidersRoute });

function IdentityProvidersRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[{ label: t('access.members.title') }, { label: t('access.identityProviders.title') }]}
    >
      <IdentityProvidersPage tenantId={tenant} />
    </ConsoleShell>
  );
}
